import { TPatchEmployee, TPostEmployee, TQueryEmployee } from '@src/modules'

import { request } from './config'

export const getListEmployee = (params: TQueryEmployee, token: string) =>
  request({ url: 'employee', method: 'GET', params }, { token })

export const getEmployeeById = (id: number, token: string) =>
  request({ url: `employee/${id}`, method: 'GET' }, { token })

export const postEmployee = (data: TPostEmployee) =>
  request({ url: 'employee', method: 'POST', data })

export const patchEmployeeById = (id: number, data: TPatchEmployee) =>
  request({ url: `employee/${id}`, method: 'PATCH', data })

export const removeEmployeeById = (id: number) =>
  request({ url: `employee/${id}`, method: 'DELETE' })
